import React, { useMemo } from 'react';
import { PAGE_TYPE } from '../../../../constants/page-settings/schedule';
import { isSameAs, unixFormat } from '../../../../helpers/times';
import { capitalizer } from '../../../../../../cp/utils';
import { useScheduleContext } from '../../../../context/ScheduleContext';
import { useModalContext } from '../../../../context/ModalContext';
import { useStreamContext } from '../../../../context/StreamContext';
import ScheduleGridCard from '../../ScheduleCards/ScheduleCardOffline/ScheduleGridCard';
import ScheduleDetailsModal from '../../ScheduleDetailsModal';
import MemberDetailsModal from '../../../Members/MembersComponents/MemberDetailsModal';

import './style.scss';

const ScheduleGridMobileView = ({
    currentUser,
    checkAuth,
    onRateEpisode,
}) => {
    const {page, schedule, isWidget, widgetSettings, scheduleFilters} = useScheduleContext();
    const streamContext = useStreamContext();
    const {renderModal} = useModalContext();

    if (!schedule?.length) {
        return null;
    }

    return (
        <div className="schedule-grid-mobile">
            {
                scheduleFilters.scheduleDates.map(({value: scheduleDate}) => (
                    <React.Fragment key={scheduleDate}>
                        {(isWidget ? widgetSettings?.daysView === PAGE_TYPE : page?.settings?.daysView === PAGE_TYPE) &&
                            <div className="schedule-view-date">
                                {capitalizer(unixFormat(scheduleDate, 'dddd DD MMMM YYYY'))}
                            </div>
                        }
                        {
                            schedule.filter(({timeStart}) => isSameAs(timeStart, scheduleDate)).map((episode) => (
                                <ScheduleGridCard
                                    key={episode.id}
                                    episode={episode}
                                    settings={isWidget ? widgetSettings : page?.settings ?? null}
                                    showHall={streamContext.streams?.length > 1}
                                    onEpisodeClick={(episode) => {
                                        renderModal(
                                            ScheduleDetailsModal,
                                            {episode, settings: isWidget ? widgetSettings : page.settings},
                                            null,
                                            (isWidget ? !!widgetSettings?.showEpisodePopup : true)
                                        );
                                    }}
                                    onMemberSelect={(member) => {
                                        renderModal(
                                            MemberDetailsModal,
                                            {member, lockPageScroll: false, settings: isWidget ? widgetSettings : page?.settings ?? null},
                                            null,
                                            (isWidget ? !!widgetSettings?.showMemberPopup : true)
                                        );
                                    }}
                                    checkAuth={checkAuth}
                                    onRateEpisode={onRateEpisode}
                                    currentUser={currentUser}
                                />
                            ))
                        }
                    </React.Fragment>
                ))
            }
        </div>
    )
};

export default ScheduleGridMobileView;
